export enum MapButtonThemes {
  Theme1 = 'theme_1',
  Theme2 = 'theme_2',
  Theme3 = 'theme_3',
}
